// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Roboto, sans-serif;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

p,
label {
  line-height: 1.5em;
}

.extra-large-img {
  width: 250px;
  height: auto;
}

.large-img {
  width: 175px;
  height: auto;
}

.medium-img {
  width: 150px;
  height: auto;
}

.small-img {
  width: 125px;
  height: auto;
}

.tiny-img {
  width: 100px;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./app/global-styles.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd","sourcesContent":["body {\n  font-family: Roboto, sans-serif;\n}\n\n#app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\np,\nlabel {\n  line-height: 1.5em;\n}\n\n.extra-large-img {\n  width: 250px;\n  height: auto;\n}\n\n.large-img {\n  width: 175px;\n  height: auto;\n}\n\n.medium-img {\n  width: 150px;\n  height: auto;\n}\n\n.small-img {\n  width: 125px;\n  height: auto;\n}\n\n.tiny-img {\n  width: 100px;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
